// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-input {
  flex-direction: "row";
  position: relative;
}

.time-input {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  width: 100%;
}
.time-input__input-left {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  height: 56px;
  width: 100%;
  border: 1px solid #e9e9e9;
  background: #ffffff;
  border-radius: 8px;
  padding-left: 16px;
}
.time-input__input-right {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  height: 56px;
  width: 100%;
  border: 1px solid #e9e9e9;
  background: #ffffff;
  border-radius: 8px;
  padding-left: 10px;
}
.time-input__label {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #353d47;
}
.time-input__default {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #C1C1C1;
  cursor: pointer;
}

input#timepicker::-webkit-calendar-picker-indicator {
  display: block;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0);
  position: absolute;
}

.time-left {
  position: absolute;
  top: 18px;
  left: 20px;
  z-index: 0;
  cursor: pointer;
}

.time-right {
  position: absolute;
  top: 18px;
  right: 20px;
  z-index: 0;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/common/time-input/time-input.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AACJ;AACI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EAEA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAAR;AAGI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EAEA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAFR;AAKI;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAHR;AAMI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAJR;;AAgBA;EACI,cAAA;EACA,MAAA;EACA,OAAA;EACA,4BAAA;EACA,kBAAA;AAbJ;;AAgBE;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AAbN;;AAgBE;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;AAbN","sourcesContent":[".text-input {\n    flex-direction: 'row';\n    position: relative;\n}\n\n.time-input {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    width: 100%;\n\n    &__input-left {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        height: 56px;\n\n        width: 100%;\n        border: 1px solid #e9e9e9;\n        background: #ffffff;\n        border-radius: 8px;\n        padding-left: 16px;\n    }\n\n    &__input-right {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        height: 56px;\n\n        width: 100%;\n        border: 1px solid #e9e9e9;\n        background: #ffffff;\n        border-radius: 8px;\n        padding-left: 10px;\n    }\n\n    &__label {\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        color: #353d47;\n    }\n\n    &__default {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        color: #C1C1C1;\n        cursor: pointer;\n    }\n}\n\n// input[type='time']::-webkit-calendar-picker-indicator {\n//     opacity: 0;\n//     margin-right: 570px;\n//     position: absolute;\n//     height: 50px;\n//     width: 40px;\n// }\n\ninput#timepicker::-webkit-calendar-picker-indicator{\n    display:block;\n    top:0;\n    left:0;\n    background: #0000;\n    position:absolute;\n  }\n\n  .time-left {\n      position: absolute;\n      top: 18px;\n      left: 20px;\n      z-index: 0;\n      cursor: pointer;\n  }\n\n  .time-right {\n      position: absolute;\n      top: 18px;\n      right: 20px;\n      z-index: 0;\n      cursor: pointer;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
